import { isSwrKeyMounted as e, mountSwrKey as t } from "./mounted-swr-keys.mjs";
import { useCallback as n, useEffect as r } from "react";
import { useSWRConfig as i } from "swr";
//#region src/hooks/use-revalidate-modules.ts
var a = (e) => JSON.stringify(typeof e == "function" ? e() : e), o = (e) => {
	let n = a(e);
	r(() => t(n), [n]);
}, s = () => {
	let { mutate: t, cache: r } = i();
	return { revalidateModules: n(async (n, i = !1) => {
		let o = (t) => i || !e(a(t)), s = Array.from(r.keys());
		for (let e of s) typeof e == "string" && e.startsWith("$inf$") && n.some((t) => e.includes(t)) && await t(e);
		await t((e) => Array.isArray(e) ? e.some((e) => n.includes(e)) && o(e) : !1, void 0), await t((e) => Array.isArray(e) ? e.some((e) => n.includes(e)) && !o(e) : !1);
	}, [r, t]) };
};
//#endregion
export { s as useRevalidateModules, o as useTrackedSWRKey };
